/**
 * Měření checkout funnelu přes LogRocket (feature flag %system.checkoutFunnelTracking%).
 *
 * LogRocket SDK se nahrává mimo repo (GTM) a typicky až po consentu — eventy se
 * proto bufferují a odešlou, jakmile je window.LogRocket k dispozici. Bez SDK
 * (flag vypnutý, odmítnutý consent, adblock) je vše tiché no-op.
 *
 * Zapnutí poznáme podle script tagu s data-funnel-step, který renderuje layout
 * jen při zapnutém flagu — React bundle tak nepotřebuje vlastní props plumbing.
 */

type FunnelProps = Record<string, string | number | boolean>;

interface LogRocketSdk {
    track: (name: string, props?: FunnelProps) => void;
}

const POLL_MS = 500;
const MAX_WAIT_MS = 20000;

let buffer: Array<{ name: string; props?: FunnelProps }> = [];
let pollTimer: number | null = null;
let waited = 0;

function sdk(): LogRocketSdk | null {
    const lr = (window as { LogRocket?: LogRocketSdk }).LogRocket;
    return lr && typeof lr.track === 'function' ? lr : null;
}

function isEnabled(): boolean {
    return document.querySelector('script[data-funnel-step]') !== null;
}

function flush(lr: LogRocketSdk): void {
    buffer.forEach(({ name, props }) => lr.track(name, props));
    buffer = [];
}

function schedulePoll(): void {
    if (pollTimer !== null) {
        return;
    }
    waited = 0;
    pollTimer = window.setInterval(() => {
        const lr = sdk();
        if (lr) {
            window.clearInterval(pollTimer as number);
            pollTimer = null;
            flush(lr);
            return;
        }
        waited += POLL_MS;
        if (waited >= MAX_WAIT_MS) {
            window.clearInterval(pollTimer as number);
            pollTimer = null;
            buffer = [];
        }
    }, POLL_MS);
}

export function trackFunnel(name: string, props?: FunnelProps): void {
    if (!isEnabled()) {
        return;
    }
    const lr = sdk();
    if (lr) {
        flush(lr);
        lr.track(name, props);
        return;
    }
    buffer.push({ name, props });
    schedulePoll();
}
